import React from 'react';
import { Body, Heading } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import { useTranslation } from 'react-i18next';

type Props = {
  activeStep: number;
  activityName: string;
  activityShortId?: string;
};

const getBodyText = (activeStep: number) => {
  switch (activeStep) {
    case 0:
      return 'trackProductStep.note';
    case 1:
      return 'testStep.note';
    default:
      return 'shareFeedbackStep.note';
  }
};

const ActivityInformation: React.FC<Props> = ({
  activeStep,
  activityName,
  activityShortId
}) => {
  const { t } = useTranslation('ihut');

  return (
    <>
      <Heading size="medium">
        {t('selectedActivity.productFeedback', { activityName })}
        <br />
        {activityShortId && (
          <Heading size="medium" UNSAFE_className={styles.regular}>
            ({t('selectedActivity.id', { activityId: activityShortId })})
          </Heading>
        )}
      </Heading>
      <Body size="large">{t(getBodyText(activeStep))}</Body>
    </>
  );
};

export default ActivityInformation;
